module.exports = __webpack_public_path__ + "static/media/NewsPaper_ Wasabi_FMShimabara.a84542d6.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/NewsPaper_ Wasabi_FMShimabara.JPG
// module id = 285
// module chunks = 0